import { render, staticRenderFns } from "./OfficesBusinessIcon.vue?vue&type=template&id=6a509414&"
import script from "./OfficesBusinessIcon.vue?vue&type=script&lang=js&"
export * from "./OfficesBusinessIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports